import React from 'react'

import { Breadcrumb } from 'app/components'

const BreadcrumbPadrao = props => {
    return (
        <Breadcrumb
            {...props}
        />
    )
}

export default BreadcrumbPadrao